import React from 'react';
import { Link } from 'react-router';
import type { StudyKeyParametersPageQuery } from '~/apollo/generated/v4/graphql';
import {
  KPCol,
  KPGrid,
} from '~/components/key-parameters/key-parameters-panel-v4/combined-view';
import { otherWikiDetailRoute } from '~/paths';
import { isNilOrEmpty } from '~/utils/common';

type PropertyDisplayProps = {
  label: React.ReactNode;
  children: React.ReactNode;
  shouldRender: boolean;
};

function PropertyDisplay({
  label,
  shouldRender,
  children,
}: PropertyDisplayProps) {
  if (!shouldRender) return null;
  return (
    <KPGrid>
      <KPCol span={5}>
        <strong>{label}</strong>
      </KPCol>
      <KPCol span={7}>{children}</KPCol>
    </KPGrid>
  );
}

export function StudyQualityParametersTable({
  study,
}: {
  study: NonNullable<StudyKeyParametersPageQuery['studyGet']>;
}) {
  const joinMany = (values?: string[] | null) => values?.join(', ') ?? '';

  return (
    <>
      <PropertyDisplay
        label="Spatial observation type"
        shouldRender={!isNilOrEmpty(study.spatialObservationType)}
      >
        <Link to={otherWikiDetailRoute(14)} target="_blank" className="link">
          {study.spatialObservationType}
        </Link>
      </PropertyDisplay>

      <PropertyDisplay
        label="Data acquisition method"
        shouldRender={!isNilOrEmpty(study.dataAcquisitionMethod)}
      >
        <Link to={otherWikiDetailRoute(7)} target="_blank" className="link">
          {joinMany(study.dataAcquisitionMethod)}
        </Link>
      </PropertyDisplay>

      <PropertyDisplay
        label="Publication type"
        shouldRender={!isNilOrEmpty(study.publicationType)}
      >
        <Link to={otherWikiDetailRoute(17)} target="_blank" className="link">
          {joinMany(study.publicationType)}
        </Link>
      </PropertyDisplay>
    </>
  );
}
